/*
 * @Date: 2023-10-08 18:12:26
 * @Description: 工具函数库
 */

// 获取省份meta信息
export function getProvinceMeta(config, defaultObj) {
  /**
   * config = {
   *    title: '北京月度',
   *    productId: [2112],
   *    timeApi: "getYears",
   *    timeParam: "C"
   * };
   *
   * defaultObj: {
   *    flowDefault: "3",
   *    coinDefault: "2",
   *    goodsDefualt: "100000",
   *    mainbodyDefault: "11",
   *    partnerDefault: "0",
   *    wayDefault: "0"
   * }
   */
  return {
    title: config.title,
    showOnlyOneChild: true,
    productId: config.productId,
    viewsInstance: "china,monthly", // 对应的组件地址
    timeApi: config.timeApi, // 时间获取接口C
    timeParam: config.timeParam, // 调用方法时使用的参数
    tableApi: "chinaTradeMonth",
    exportTableApi: "exportChinaTradeMonth",
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        controlDimension: "hsId",
        components: "china-month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: defaultObj.flowDefault, // 默认进出口
        options: [
          {
            label: "进出口",
            value: "3",
          },
          {
            label: "进口",
            value: "1",
          },
          {
            label: "出口",
            value: "0",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "moneyItype",
        default: defaultObj.coinDefault,
        options: [
          {
            label: "美元",
            value: "2",
          },
          {
            label: "人民币",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: defaultObj.goodsDefualt, // 默认商品
        options: [],
        paramName: "hsId",
        dimensionParamName: "",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "HaiGuanGoods",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "regionId",
        default: defaultObj.mainbodyDefault, // 默认主体
        options: [],
        // showSelect: config.showSelect || false,   //控制主体是否能选择
        showSelect: true,
        components: "SelectInput",
        componentType: "ComRtDataChainQy",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "stateId",
        default: defaultObj.partnerDefault, // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "HaiGuanState",
        className: "w350",
        con: {},
      },
      {
        type: "way",
        label: "方式",
        paramName: "trademodeId",
        default: defaultObj.wayDefault, // 默认方式
        options: [],
        components: "SelectInput",
        componentType: "Trademode",
        className: "w320",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "dateTime",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "ioreName",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "regionName",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "stateName",
        width: "160",
        func: "",
      },
      {
        label: "方式中文名称",
        row: "trademodeName",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hsId",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hsName",
        width: "110",
        func: "",
      },

      {
        label: "金额",
        row: "moneyAmount",
        width: "160",
        func: "numFormat",
        formatter: "formatColAmount",
        align: "right",
      },
      {
        label: "第一数量",
        row: "amount",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "第一计量单位",
        row: "hsUnitsName",
        width: "160",
        func: "",
      },
      {
        label: "第二数量",
        row: "secondAmount",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "第二计量单位",
        row: "hsUnitsNameTwo",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "regionId",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "stateId",
        width: "160",
        func: "",
      },
      {
        label: "方式编码",
        row: "trademodeId",
        width: "160",
        func: "",
      },
    ],
  };
}
